(() => {
  if (window.cppShopV2Loaded) return;
  window.cppShopV2Loaded = true;
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = matchMedia('(hover: hover) and (pointer: fine)');
  const active = new Set();
  function stop(card) {
    card.classList.remove('is-previewing', 'is-video-playing');
    active.delete(card);
    const video = card.querySelector('video');
    if (video) { video.pause(); try { video.currentTime = 0; } catch (_) {} }
    card.querySelector('[data-media-toggle]')?.setAttribute('aria-pressed', 'false');
  }
  async function start(card, explicit = false) {
    if (reducedMotion.matches && !explicit) return;
    active.forEach(other => { if (other !== card) stop(other); });
    card.classList.add('is-previewing');
    active.add(card);
    card.querySelector('[data-media-toggle]')?.setAttribute('aria-pressed', 'true');
    const video = card.querySelector('video');
    if (!video) return;
    if (!video.getAttribute('src')) video.src = video.dataset.src;
    video.muted = true;
    try { await video.play(); if (active.has(card)) card.classList.add('is-video-playing'); else video.pause(); } catch (_) { /* Keep the second image when playback is unavailable. */ }
  }
  const visibility = new IntersectionObserver(entries => entries.forEach(entry => { if (!entry.isIntersecting) stop(entry.target); }));
  function init(root = document) {
    root.querySelectorAll('[data-shop-media]').forEach(card => {
      if (card.dataset.mediaReady) return;
      card.dataset.mediaReady = 'true';
      visibility.observe(card);
      card.addEventListener('pointerenter', () => { if (finePointer.matches) start(card); });
      card.addEventListener('pointerleave', () => { if (finePointer.matches) stop(card); });
      card.addEventListener('focusin', event => { if (!event.target.matches('[data-media-toggle]') && finePointer.matches) start(card); });
      card.addEventListener('focusout', event => { if (!card.contains(event.relatedTarget)) stop(card); });
      const toggle = card.querySelector('[data-media-toggle]');
      if (toggle) { toggle.hidden = false; toggle.addEventListener('click', () => active.has(card) ? stop(card) : start(card, true)); }
      card.addEventListener('keydown', event => { if (event.key === 'Escape') stop(card); });
    });
    root.querySelectorAll('[data-shop-demo]').forEach(catalog => {
      if (catalog.dataset.ready) return;
      catalog.dataset.ready = 'true';
      const controls = catalog.querySelector('[data-shop-filters]');
      const grid = catalog.querySelector('[data-shop-all]');
      const count = catalog.querySelector('[data-shop-count]');
      if (!controls || !count || !grid) return;
      controls.hidden = false;
      const cards = [...grid.querySelectorAll('[data-shop-category]')];
      controls.addEventListener('click', event => {
        const button = event.target.closest('button[data-category]');
        if (!button) return;
        controls.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        let visible = 0;
        cards.forEach(card => {
          card.hidden = button.dataset.category !== 'all' && !card.dataset.shopCategory.split(' ').includes(button.dataset.category);
          if (card.hidden) stop(card); else visible++;
        });
        const featured = catalog.querySelector('[data-shop-featured]');
        if (featured) { featured.hidden = button.dataset.category !== 'all'; featured.querySelectorAll('[data-shop-media]').forEach(stop); }
        count.textContent = `${visible} sample ${visible === 1 ? 'design' : 'designs'}`;
      });
      const sort = catalog.querySelector('[data-shop-sort]');
      sort?.addEventListener('change', () => {
        const ordered = [...cards];
        if (sort.value !== 'featured') ordered.sort((a,b) => a.dataset.title.localeCompare(b.dataset.title) * (sort.value === 'title-descending' ? -1 : 1));
        ordered.forEach(card => grid.append(card));
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-shop-media]').forEach(card => { stop(card); visibility.unobserve(card); }));
  document.addEventListener('visibilitychange', () => { if (document.hidden) active.forEach(stop); });
  reducedMotion.addEventListener('change', () => active.forEach(stop));
})();
